import { useCreatorCohorts } from "@/api/creator-cohorts";
import type { InvitedCreator } from "../modals/create-collab-group-modal";
import { buildSegments, ProgressBar, type Segment } from "./ProgressBar";

const FIXED_CATEGORY_ORDER = ["Worked With Previously", "Previously Invited", "New Creator"];

export function categorizeInvitedCreator(creator: InvitedCreator, cohortNameById: Map<string, string>): string {
  if (creator.cohortId) return cohortNameById.get(creator.cohortId) ?? "Cohort";
  if (creator.isCreator) return "Worked With Previously";
  if (creator.previouslyInvited) return "Previously Invited";
  return "New Creator";
}

export function buildInvitedCreatorSegments(
  creators: InvitedCreator[],
  cohortNameById: Map<string, string>,
): Segment[] {
  const labels = creators.map((creator) => categorizeInvitedCreator(creator, cohortNameById));
  return buildSegments(labels, FIXED_CATEGORY_ORDER);
}

type InvitedCreatorsDistributionProps = {
  creators: InvitedCreator[];
};

export const InvitedCreatorsDistribution = ({ creators }: InvitedCreatorsDistributionProps) => {
  const { data: cohorts = [] } = useCreatorCohorts();
  const cohortNameById = new Map(cohorts.map((cohort) => [cohort.id, cohort.name]));
  const segments = buildInvitedCreatorSegments(creators, cohortNameById);

  return <ProgressBar segments={segments} />;
};
